<div class="tw-flex tw-items-center {{classes}}">
  <div class="tw-flex tw-flex-col tw-gap-0.5">
    <div class="tw-font-semibold {{classes}}" *ngIf="firstLine">
      <ng-content select="[firstLine]"></ng-content>
    </div>
    <div *ngIf="secondLine" class="{{classes}}">
      <ng-content select="[secondLine]"></ng-content>
    </div>
    <div *ngIf="thirdLine" class="{{classes}}">
      <ng-content select="[thirdLine]"></ng-content>
    </div>
    <div *ngIf="fourthLine" class="{{classes}}">
      <ng-content select="[fourthLine]"></ng-content>
    </div>
    <div *ngIf="fifthLine" class="{{classes}}">
      <ng-content select="[fifthLine]"></ng-content>
    </div>
  </div>
</div>
